import React from 'react';
import PropTypes from 'prop-types';
import Icon from './Icon';

function getClassName(type, selected, disabled, enabled, className) {
  const classNames = [type];
  if (selected) classNames.push(`${type}--selected`);
  if (disabled) classNames.push(`${type}--disabled`);
  if (className) classNames.push(className);
  return classNames.join(' ');
}

// function createMarkup(text) {
//   return { __html: text };
// }

function Link(props) {
  const disabled = !props.disabled
    ? !(props.href || props.onClick || props.onMouseEnter || props.onMouseLeave)
    : props.disabled;
  const href = disabled ? null : props.href || null;
  const onClick = disabled ? null : props.onClick || null;
  const handleMouseEnter =
    disabled || !props.onMouseEnter ? null : () => props.onMouseEnter(props.id);
  const handleMouseLeave =
    disabled || !props.onMouseLeave ? null : () => props.onMouseLeave(props.id);
  const className = getClassName(
    props.type,
    props.selected,
    disabled,
    props.enabled,
    props.className
  );
  return (
    <a
      className={className}
      title={props.title}
      data-testid={props.testId}
      id={props.id}
      href={href}
      target={props.target}
      onClick={onClick}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      {props.icon ? <Icon {...props.icon} /> : null}
      {props.text ? <span>{props.text}</span> : null}
    </a>
  );
}

Link.defaultProps = {
  type: 'link',
  href: null,
  text: null,
  target: '_blank',
  className: null,
  id: null,
  icon: null,
  title: null,
  onClick: null,
  onMouseEnter: null,
  onMouseLeave: null,
  selected: false,
  disabled: false,
  enabled: true,
  testId: 'Link'
};
Link.propTypes = {
  type: PropTypes.oneOf(['link', 'button']),
  href: PropTypes.string,
  text: PropTypes.string,
  target: PropTypes.string,
  className: PropTypes.string,
  id: PropTypes.string,
  icon: PropTypes.shape(Icon.propTypes),
  title: PropTypes.string,
  onClick: PropTypes.func,
  onMouseEnter: PropTypes.func,
  onMouseLeave: PropTypes.func,
  selected: PropTypes.bool,
  disabled: PropTypes.bool,
  enabled: PropTypes.bool,
  testId: PropTypes.string
};

export default Link;



// WEBPACK FOOTER //
// ./src/components/ui/Link.jsx